import script from "./Msg.vue?vue&type=script&setup=true&lang=js"
export * from "./Msg.vue?vue&type=script&setup=true&lang=js"

import "./Msg.vue?vue&type=style&index=0&id=db6a9ac0&lang=less"

const __exports__ = script;

export default __exports__